import React, { useState, useEffect, useRef } from 'react';
import { Table, Button, Avatar,Statistic, Tag, Typography, Input, Select, DatePicker, Space, Row, Col, Card, Tooltip, Badge, message, Pagination, Modal, Form, InputNumber, Alert, Divider } from 'antd';
import SearchFieldsSelect, { useSearchFields, getSearchFieldsPlaceholder } from '../../Components/SearchFieldsSelect/SearchFieldsSelect';
import { 
  UserOutlined, 
  MailOutlined, 
  PhoneOutlined, 
  EyeOutlined,
  SearchOutlined,
  ReloadOutlined,
  CalendarOutlined,
  DollarOutlined,
  ClockCircleOutlined,
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  CopyOutlined,
  FileTextOutlined,
  ClearOutlined,
  CreditCardOutlined,
  TeamOutlined,
  CheckCircleOutlined,
  WalletOutlined,
  HistoryOutlined,
  CommentOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import API from '../../API/API';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { ROUTES } from '../../Routes/Routes';
import { motion } from 'framer-motion';
import { TbCircleDottedLetterQ } from 'react-icons/tb';

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);

const { Text, Title } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

const PendingPayment = () => {
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editingValue, setEditingValue] = useState('');
  
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(24);
  const [totalRecords, setTotalRecords] = useState(0);
  const [editingSalesMadeId, setEditingSalesMadeId] = useState(null);
  const [editingSalesMadeDate, setEditingSalesMadeDate] = useState(null);
  const [savingSalesMade, setSavingSalesMade] = useState(false);
  
  // Modal state for Amount edit
  const [isAmountModalVisible, setIsAmountModalVisible] = useState(false);
  const [selectedLeadForAmount, setSelectedLeadForAmount] = useState(null);
  const [savingAmount, setSavingAmount] = useState(false);
  const [amountForm] = Form.useForm();
const [serviceAgentsMap, setServiceAgentsMap] = useState({});
const [loadingServiceAgents, setLoadingServiceAgents] = useState(false);
const [selectedServiceAgentId, setSelectedServiceAgentId] = useState(null);
   const [commentsModalVisible, setCommentsModalVisible] = useState(false);
   const [selectedLeadForComment, setSelectedLeadForComment] = useState(null);
   const [newComment, setNewComment] = useState('');
   const [addingComment, setAddingComment] = useState(false);
const [savingPaymentStatus, setSavingPaymentStatus] = useState(false);
const [specificationModalVisible, setSpecificationModalVisible] = useState(false);
const [selectedLeadForSpecification, setSelectedLeadForSpecification] = useState(null);
const [tempSpecification, setTempSpecification] = useState('');
const [savingSpecification, setSavingSpecification] = useState(false);

const [serviceAgentModalVisible, setServiceAgentModalVisible] = useState(false);
const [selectedLeadForServiceAgent, setSelectedLeadForServiceAgent] = useState(null);
const [selectedServiceAgentForLead, setSelectedServiceAgentForLead] = useState(null);
const [savingServiceAgent, setSavingServiceAgent] = useState(false);

  const [sortedInfo, setSortedInfo] = useState({
    field: 'saleMadeDate',
    order: 'descend',
  });
  const [filteredInfo, setFilteredInfo] = useState({
    part: null,
    paymentStatus: null,
    agent: null,
  });
  const [loginAgent, setLoginAgent] = useState({});
  
  // Agent filter state
  const [agents, setAgents] = useState([]);
  const [selectedAgentId, setSelectedAgentId] = useState(null);
  
  // Search and filter states
  const [searchText, setSearchText] = useState('');
  // The search a request uses: the box's text, set 0.5 s after typing pauses
  // (at once when the box is cleared), so a search is not sent per keystroke.
  const [searchQuery, setSearchQuery] = useState('');
  useEffect(() => {
    const trimmed = searchText.trim();
    if (!trimmed) {
      setSearchQuery('');
      return undefined;
    }
    const timer = setTimeout(() => setSearchQuery(trimmed), 500);
    return () => clearTimeout(timer);
  }, [searchText]);
  const [searchFields, setSearchFields] = useSearchFields('pending-payment:search-fields');
  // The "Search in" group only changes the results of a search, so changing it
  // with an empty search box sends no request.
  const effectiveSearchFields = searchQuery ? searchFields : null;
  const [dateRange, setDateRange] = useState(() => {
    const now = dayjs();
    return [now.startOf('month'), now.endOf('month')];
  });
  const [quickDateFilter, setQuickDateFilter] = useState('thisMonth');

  const [editingPaymentDateId, setEditingPaymentDateId] = useState(null);
const [editingPaymentDate, setEditingPaymentDate] = useState(null);
const [savingPaymentDate, setSavingPaymentDate] = useState(false);

  const isAdmin = loginAgent?.role === "ADMIN";
const handleSpecificationEdit = (record) => {
    // ✅ LOG to verify record data
    console.log("Editing record:", record);
    console.log("Record ID:", record._id);
    console.log("Current specification:", record.vehicleInfo?.specification);
    
    const currentSpec = record.vehicleInfo?.specification || '';
    setSelectedLeadForSpecification(record);
    setTempSpecification(currentSpec);
    setSpecificationModalVisible(true);
};

// Handle saving the specification
const handleSpecificationSave = async () => {
    if (!selectedLeadForSpecification) return;
    
    setSavingSpecification(true);
    
    try {
        const payload = {
            vehicleInfo: {
                ...selectedLeadForSpecification.vehicleInfo,
                specification: tempSpecification.trim() || ''
            }
        };
        
        // ✅ ADD MORE LOGGING
        console.log("Saving specification for lead ID:", selectedLeadForSpecification._id);
        console.log("Payload being sent:", JSON.stringify(payload, null, 2));
        
        const response = await API.UpdateLead(selectedLeadForSpecification._id, payload);
        
        // ✅ LOG THE FULL RESPONSE
        console.log("Full API Response:", response);
        
        if (response?.status) {
            message.success('Vehicle specification updated successfully!');
            setSpecificationModalVisible(false);
            setSelectedLeadForSpecification(null);
            setTempSpecification('');
            fetchLeads(true); // Refresh the list
        } else {
            console.error("API returned error:", response);
            message.error(response?.message || 'Failed to update specification');
        }
    } catch (error) {
        console.error('Detailed error:', error);
        console.error('Error response:', error.response);
        console.error('Error message:', error.message);
        message.error(error?.response?.data?.message || 'Failed to save specification');
    } finally {
        setSavingSpecification(false);
    }
};
  // Handle opening the service agent selection modal
const handleServiceAgentEdit = (record) => {
    const currentServiceAgentId = record.orderServiceHandledBy?._id || record.orderServiceHandledBy;
    setSelectedLeadForServiceAgent(record);
    setSelectedServiceAgentForLead(currentServiceAgentId || null);
    setServiceAgentModalVisible(true);
};

// Handle saving the service agent
const handleServiceAgentSave = async () => {
    if (!selectedLeadForServiceAgent) return;
    
    setSavingServiceAgent(true);
    
    try {
        const payload = {
            orderServiceHandledBy: selectedServiceAgentForLead || null // Set to null if unassigned
        };
        
        const response = await API.UpdateLead(selectedLeadForServiceAgent._id, payload);
        
        if (response?.status) {
            message.success(selectedServiceAgentForLead ? 'Service agent assigned successfully!' : 'Service agent unassigned successfully!');
            
            // Update local state
            setLeads(prevLeads => 
                prevLeads.map(lead => 
                    lead._id === selectedLeadForServiceAgent._id ? { 
                        ...lead, 
                        orderServiceHandledBy: selectedServiceAgentForLead
                    } : lead
                )
            );
            
            // Close modal
            setServiceAgentModalVisible(false);
            setSelectedLeadForServiceAgent(null);
            setSelectedServiceAgentForLead(null);
            
            // Refresh leads to get populated agent data
            fetchLeads(true);
            fetchServiceAgents(); // Refresh the agents map
        } else {
            message.error(response?.message || 'Failed to assign service agent');
        }
    } catch (error) {
        console.error('Error assigning service agent:', error);
        message.error('Failed to save service agent assignment');
    } finally {
        setSavingServiceAgent(false);
    }
};

const handlePaymentDateUpdate = async (id) => {
    if (!editingPaymentDate) {
        message.warning('Please select a date');
        return;
    }

    setSavingPaymentDate(true);

    try {
        const currentLead = leads.find(lead => lead._id === id);
        const advancePayments = currentLead?.advancePayments || [];
        
        if (advancePayments.length === 0) {
            message.warning('No payment found to update');
            return;
        }
        
        // Get the latest payment
        const latestPayment = [...advancePayments].sort((a, b) => new Date(b.date) - new Date(a.date))[0];
        
        // Send the COMPLETE payment object with updated date
        const updatedPayment = {
            ...latestPayment,  // Keep ALL existing fields
            date: editingPaymentDate.toISOString()  // Only change the date
        };
        
        const payload = {
            advancePayments: [updatedPayment]  // Send the complete payment object
        };

        const response = await API.UpdateLead(id, payload);

        if (response?.status) {
            message.success('Payment date updated successfully!');
            fetchLeads(true);
            setEditingPaymentDateId(null);
            setEditingPaymentDate(null);
        } else {
            message.error(response?.message || 'Failed to update payment date');
        }
    } catch (error) {
        console.error('Error updating payment date:', error);
        message.error('Failed to save payment date');
    } finally {
        setSavingPaymentDate(false);
    }
};

const handlePaymentDateEditStart = (record) => {
  const lastPaymentDate = getLastPaymentDate(record);
  setEditingPaymentDateId(record._id);
  setEditingPaymentDate(lastPaymentDate ? dayjs(lastPaymentDate) : dayjs());
};

const handlePaymentDateEditCancel = () => {
  setEditingPaymentDateId(null);
  setEditingPaymentDate(null);
};

const handlePaymentStatusUpdate = async (id) => {
  const currentLead = leads.find(lead => lead._id === id);

  if (!hasPaymentServiceAgentAssigned(currentLead)) {
    setEditingValue(currentLead?.payementAllow || 'No');
    showMissingPaymentServiceAgentError();
    return;
  }

  if (!editingValue) {
    message.warning('Please select a status');
    return;
  }

  if (!editingSalesMadeDate) {
    message.warning('Please select a date');
    return;
  }

  setSavingPaymentStatus(true);

  try {
    let existingHistory = currentLead?.payementAllowHistory || [];
    
    // Check if there's already an entry with this status
    const existingEntryIndex = existingHistory.findIndex(
      entry => entry.value === editingValue
    );
    
    let updatedHistory;
    
    if (existingEntryIndex !== -1) {
      // Update existing entry's date
      updatedHistory = [...existingHistory];
      updatedHistory[existingEntryIndex] = {
        ...updatedHistory[existingEntryIndex],
        changedAt: editingSalesMadeDate.toISOString()
      };
    } else {
      // Add new entry
      const newHistoryEntry = {
        value: editingValue,
        changedAt: editingSalesMadeDate.toISOString()
      };
      updatedHistory = [...existingHistory, newHistoryEntry];
    }
    
    const payload = {
      payementAllow: editingValue,
      payementAllowHistory: updatedHistory
    };

    const response = await API.UpdateLead(id, payload);

    if (response?.status) {
      message.success('Payment status updated successfully with date!');
      fetchLeads(true);
      setEditingId(null);
      setEditingValue('');
      setEditingSalesMadeDate(null);
    } else {
      message.error(response?.message || 'Failed to update payment status');
    }
  } catch (error) {
    console.error('Error updating payment status:', error);
    message.error('Failed to save payment status');
  } finally {
    setSavingPaymentStatus(false);
  }
};

const handleAddComment = async () => {
    if (!newComment.trim()) {
        message.warning('Please enter a comment');
        return;
    }

    if (!selectedLeadForComment) return;

    setAddingComment(true);
    try {
        const existingComments = selectedLeadForComment.paymentPageComment || [];
        const payload = {
            paymentPageComment: [
                ...existingComments,
                {
                    comment: newComment.trim(),
                    changedAt: new Date().toISOString()
                }
            ]
        };

        const response = await API.UpdateLead(selectedLeadForComment._id, payload);

        if (response?.status) {
            message.success('Comment added successfully!');
            setNewComment('');
            setCommentsModalVisible(false);
            setSelectedLeadForComment(null);
            // Refresh the leads list
            fetchLeads();
        } else {
            message.error(response?.message || 'Failed to add comment');
        }
    } catch (error) {
        console.error('Error adding comment:', error);
        message.error('Failed to add comment');
    } finally {
        setAddingComment(false);
    }
};
const formatCommentDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    });
};

// API dates remain YYYY-MM-DD for backend-safe filtering.
const formatDateDMY = (date) => {
  if (!date) return 'N/A';
  return dayjs(date).format('MM/DD/YYYY');
};
useEffect(() => {
  if (isAmountModalVisible && selectedLeadForAmount) {
    const subscription = amountForm.getFieldsValue();
    // You can add a watcher here if needed
  }
}, [isAmountModalVisible, amountForm, selectedLeadForAmount]);
  // Helper function to format datetime as DD/MM/YYYY HH:mm
const formatDateTimeDMY = (date) => {
  if (!date) return 'N/A';
  return dayjs(date).format('MM/DD/YYYY HH:mm');
};

  // Get Sales Made Date from lead stage history
  const getSalesMadeDate = (lead) => {
    const salesMadeStage = lead.leadStageHistory?.find(
      stage => stage.stage === 'Sales Made'
    );
    return salesMadeStage?.changedAt || null;
  };

  // Get Last Payment Date
  const getLastPaymentDate = (record) => {
    const advancePayments = record.advancePayments || [];
    if (advancePayments.length === 0) return null;
    const latestPayment = [...advancePayments].sort((a, b) => new Date(b.date) - new Date(a.date))[0];
    return latestPayment?.date || null;
  };

  const handleSalesMadeDateUpdate = async (id) => {
    if (!editingSalesMadeDate) {
      message.warning('Please select a date');
      return;
    }

    setSavingSalesMade(true);

    try {
      const currentLead = leads.find(lead => lead._id === id);
      const existingHistory = currentLead?.leadStageHistory || [];
      
      const salesMadeIndex = existingHistory.findIndex(
        stage => stage.stage === 'Sales Made'
      );
      
      let updatedHistory;
      const dateOnly = editingSalesMadeDate.startOf('day').toISOString();
      
      if (salesMadeIndex !== -1) {
        updatedHistory = [...existingHistory];
        updatedHistory[salesMadeIndex] = {
          ...updatedHistory[salesMadeIndex],
          changedAt: dateOnly
        };
      } else {
        updatedHistory = [
          ...existingHistory,
          {
            stage: 'Sales Made',
            changedAt: dateOnly,
            comment: 'Sales Made date updated'
          }
        ];
      }
      
      const payload = { leadStageHistory: updatedHistory };
      const response = await API.UpdateLead(id, payload);

      if (response?.status) {
        message.success('Sales Made date updated successfully!');
        fetchLeads(true);
        setEditingSalesMadeId(null);
        setEditingSalesMadeDate(null);
      } else {
        message.error(response?.message || 'Failed to update Sales Made date');
      }
    } catch (error) {
      console.error('Error updating Sales Made date:', error);
      message.error('Failed to save Sales Made date');
    } finally {
      setSavingSalesMade(false);
    }
  };

  const handleSalesMadeEditStart = (record) => {
    const salesMadeDate = getSalesMadeDate(record);
    setEditingSalesMadeId(record._id);
    setEditingSalesMadeDate(salesMadeDate ? dayjs(salesMadeDate) : dayjs());
  };

  const handleSalesMadeEditCancel = () => {
    setEditingSalesMadeId(null);
    setEditingSalesMadeDate(null);
  };

const handleAmountEditOpen = (record) => {
  setSelectedLeadForAmount(record);
  amountForm.setFieldsValue({
    totalAmount: record.totalAmount || 0,
  });
  setIsAmountModalVisible(true);
};

  const handleAmountModalCancel = () => {
    setIsAmountModalVisible(false);
    setSelectedLeadForAmount(null);
    amountForm.resetFields();
  };

const handleAmountModalSave = async (values) => {
  try {
    console.log("Form submission triggered with values:", values);
    
    if (!values.totalAmount || values.totalAmount <= 0) {
      message.warning('Please enter a valid total amount');
      return;
    }
    

    
    if (values.paidAmount > values.totalAmount) {
      message.warning('Paid amount cannot exceed total amount');
      return;
    }

    setSavingAmount(true);
    
    // Calculate new balance
    const newBalance = values.totalAmount - values.paidAmount;
    
    // Determine payment status
    let paymentStatus = 'Unpaid';
    if (values.paidAmount > 0 && newBalance > 0) {
      paymentStatus = 'Partially Paid';
    } else if (newBalance <= 0 && values.paidAmount > 0) {
      paymentStatus = 'Fully Paid';
    }
    
    // Update all amount-related fields
    const response = await API.UpdateLead(selectedLeadForAmount._id, { 
      totalAmount: values.totalAmount,
      balanceAmount: newBalance,
      paymentStatus: paymentStatus
    });
    
    console.log("API Response:", response);
    
    if (response?.status) {
      message.success('Amounts updated successfully!');
      fetchLeads(true); // Refresh the data
      handleAmountModalCancel();
    } else {
      message.error(response?.message || 'Failed to update amounts');
    }
  } catch (error) {
    console.error('Error updating amounts:', error);
    message.error('Failed to save amounts');
  } finally {
    setSavingAmount(false);
  }
};

  useEffect(() => {
    const UD = localStorage.getItem('userData');
    if (!UD) {
      navigate(ROUTES?.LOGIN);
      return;
    }
    const parsedUser = JSON.parse(UD);
    setLoginAgent(parsedUser);
    
    if (parsedUser?.role === "ADMIN") {
      fetchAgents();
    }
        fetchServiceAgents(); 

  }, [navigate]);

  const getServiceAgentName = (record) => {
    const serviceAgentId = record.orderServiceHandledBy?._id || record.orderServiceHandledBy;
    if (!serviceAgentId) return null;
    
    // Check if already populated as object
    if (record.orderServiceHandledBy && typeof record.orderServiceHandledBy === 'object') {
        return `${record.orderServiceHandledBy.firstName || ''} ${record.orderServiceHandledBy.lastName || ''}`.trim() || 
               record.orderServiceHandledBy.userName || 'Service Agent';
    }
    
    // Check in our map
    const agentInfo = serviceAgentsMap[serviceAgentId];
    return agentInfo?.name || null;
};

const getPaymentServiceAgentId = (record) => {
    const serviceAgent = record?.orderServiceHandledBy;
    if (!serviceAgent) return null;
    if (typeof serviceAgent === 'object') {
        return serviceAgent._id || serviceAgent.id || serviceAgent.$oid || null;
    }
    return serviceAgent;
};

const hasPaymentServiceAgentAssigned = (record) => Boolean(getPaymentServiceAgentId(record));

const showMissingPaymentServiceAgentError = () => {
    message.error('Please assign the Payment Service-Agent');
};


  const fetchAgents = async () => {
    try {
      const response = await API.userGetAll();
      if (response?.success) {
        const salesAgents = (response.data || []).filter(user => user.role === "SALES-AGENT");
        setAgents(salesAgents);
      }
    } catch (error) {
      console.error("Failed to fetch agents", error);
    }
  };
const fetchServiceAgents = async () => {
    setLoadingServiceAgents(true);
    try {
        const response = await API.userGetAll();
        if (response?.success) {
            const agentsMap = {};
            // Get all users with SERVICE-AGENT or SUPPORT-AGENT role
            const serviceAgentsList = (response.data || []).filter(
                user => user.role === "SERVICE-AGENT" || user.role === "SUPPORT-AGENT"
            );
            serviceAgentsList.forEach(agent => {
                agentsMap[agent._id] = {
                    name: `${agent.firstName || ''} ${agent.lastName || ''}`.trim() || agent.userName || agent.email,
                    email: agent.email,
                    phone: agent.directNumber,
                    role: agent.role
                };
            });
            setServiceAgentsMap(agentsMap);
        }
    } catch (error) {
        console.error("Failed to fetch service agents", error);
    } finally {
        setLoadingServiceAgents(false);
    }
};
  const getUniqueValues = (field) => {
    const values = leads
      .map(lead => {
        if (field === 'part') {
          return lead.vehicleInfo?.part;
        }
        return lead[field];
      })
      .filter((value, index, self) => value && self.indexOf(value) === index);
    return values;
  };

  const getUniqueAgents = () => {
    const agentNames = leads
      .map(lead => {
        if (lead.assignedAgent?.name) return lead.assignedAgent.name;
        if (lead.agentName) return lead.agentName;
        return 'Unassigned';
      })
      .filter((value, index, self) => value && self.indexOf(value) === index);
    return agentNames;
  };

  const getAgentName = (record) => {
    if (record.assignedAgent?.name) return record.assignedAgent.name;
    if (record.agentName) return record.agentName;
    return 'Unassigned';
  };

  const getQuickDateRange = (filterType) => {
    const now = dayjs();
    let startDate = now;
    let endDate = now;

    switch (filterType) {
      case 'today':
        startDate = now.startOf('day');
        endDate = now.endOf('day');
        break;
      case 'yesterday':
        startDate = now.subtract(1, 'day').startOf('day');
        endDate = now.subtract(1, 'day').endOf('day');
        break;
      case 'thisWeek':
        startDate = now.startOf('week');
        endDate = now.endOf('week');
        break;
      case 'thisMonth':
        startDate = now.startOf('month');
        endDate = now.endOf('month');
        break;
      case 'lastMonth':
        startDate = now.subtract(1, 'month').startOf('month');
        endDate = now.subtract(1, 'month').endOf('month');
        break;
      case 'thisQuarter':
        startDate = now.startOf('quarter');
        endDate = now.endOf('quarter');
        break;
      case 'thisYear':
        startDate = now.startOf('year');
        endDate = now.endOf('year');
        break;
      default:
        return null;
    }

    return [startDate, endDate];
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, effectiveSearchFields, dateRange, filteredInfo, sortedInfo.field, sortedInfo.order, selectedAgentId]);

  const handleQuickDateFilter = (value) => {
    setQuickDateFilter(value);
    const newDateRange = getQuickDateRange(value);
    setDateRange(newDateRange);
    setCurrentPage(1);
  };

const fetchLeads = async (isRefresh = false) => {
  if (isRefresh) {
    setRefreshing(true);
  } else {
    setLoading(true);
  }

  try {
    const userData = JSON.parse(localStorage.getItem("userData"));

    if (!userData?.id) {
      console.error("User authentication data not found");
      setLoading(false);
      return;
    }

    const isSearching = Boolean(searchQuery);

    const params = {
      page: currentPage,
      limit: pageSize,
      status: "Sales Made",
      payementAllow: "No",
    };

    // Date filter must be applied in backend before pagination.
    // UI can show MM/DD/YYYY, but API should send YYYY-MM-DD for safe backend parsing.
    if (!isSearching && Array.isArray(dateRange) && dateRange[0] && dateRange[1]) {
      params.stageHistoryStage = "Sales Made";
      params.stageHistoryDate = dateRange[0].format("YYYY-MM-DD");
      params.stageHistoryEndDate = dateRange[1].format("YYYY-MM-DD");
    }

    if (isSearching) {
      params.search = searchQuery;
      params.searchFields = searchFields;
    }

    if (filteredInfo.part && filteredInfo.part.length > 0) {
      params.part = filteredInfo.part.join(",");
    }

    if (filteredInfo.paymentStatus && filteredInfo.paymentStatus.length > 0) {
      params.paymentStatus = filteredInfo.paymentStatus.join(",");
    }

    if (isAdmin && selectedAgentId) {
      params.agentId = selectedAgentId;
    }

    console.log("PendingPayment API params:", params);

    // The server sends only the fields this page uses
    // (LeadController LEAD_VIEW_FIELDS['pending-payment']).
    params.view = 'pending-payment';
    const response = await API.leadGetAll(params);

    if (response?.status) {
      const leadsData = response.data || [];

      // Backend already filters:
      // 1. leadStage = Sales Made
      // 2. payementAllow = No
      // 3. Sales Made date from leadStageHistory
      // So do not filter again after pagination.
      const sortedLeads = [...leadsData].sort((a, b) => {
        const dateA = getSalesMadeDate(a);
        const dateB = getSalesMadeDate(b);

        if (!dateA && !dateB) return 0;
        if (!dateA) return 1;
        if (!dateB) return -1;

        return new Date(dateB) - new Date(dateA);
      });

      setLeads(sortedLeads);
      setTotalRecords(response.pagination?.totalRecords || sortedLeads.length);
    } else {
      console.error("Invalid response format:", response);
      setLeads([]);
      setTotalRecords(0);
    }
  } catch (error) {
    console.error("Failed to fetch leads:", error);
    message.error("Failed to fetch leads");
    setLeads([]);
    setTotalRecords(0);
  } finally {
    setLoading(false);
    setRefreshing(false);
  }
};

  const handleRefresh = () => {
    fetchLeads(true);
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };

  const handleDateRangeChange = (dates) => {
    setDateRange(dates);
    setQuickDateFilter('custom');
  };

  const handleClearFilters = () => {
    setSearchText('');
    const defaultDateRange = getQuickDateRange('thisMonth');
    setDateRange(defaultDateRange);
    setQuickDateFilter('thisMonth');
    setFilteredInfo({ part: null, paymentStatus: null, agent: null });
    setSelectedAgentId(null);
    setSortedInfo({ field: 'saleMadeDate', order: 'descend' });
    setCurrentPage(1);
    message.info({
      content: "All filters cleared",
      icon: <ClearOutlined />
    });
  };

  const handleView = (record) => {
    navigate(`/lead-details/${record._id}`);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const handlePaginationChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
  };

const handleEditStart = (record) => {
  if (!hasPaymentServiceAgentAssigned(record)) {
    showMissingPaymentServiceAgentError();
    return;
  }

  // Get the history entry that matches the CURRENT status
  const paymentHistory = record.payementAllowHistory || [];
  const currentStatus = record.payementAllow || 'No';
  
  // ✅ FIND THE OLDEST (FIRST) entry with this status, not the latest
  const currentStatusEntry = [...paymentHistory]
    .sort((a, b) => new Date(a.changedAt) - new Date(b.changedAt)) // Sort ascending (oldest first)
    .find(entry => entry.value === currentStatus);
  
  // Use that entry's date, or fallback to current date
  const existingDate = currentStatusEntry?.changedAt || new Date();
  
  setEditingId(record._id);
  setEditingValue(record.payementAllow || 'No');
  setEditingSalesMadeDate(dayjs(existingDate));
};

  const handleEditCancel = () => {
    setEditingId(null);
    setEditingValue('');
  };

  const handlePaymentStatusChange = (record, value) => {
    if (!hasPaymentServiceAgentAssigned(record)) {
      setEditingValue(record.payementAllow || 'No');
      showMissingPaymentServiceAgentError();
      return;
    }

    setEditingValue(value);
  };

  const handleEditSave = async (id) => {
    const currentLead = leads.find(lead => lead._id === id);

    if (!hasPaymentServiceAgentAssigned(currentLead)) {
      setEditingValue(currentLead?.payementAllow || 'No');
      showMissingPaymentServiceAgentError();
      return;
    }

    try {
      const response = await API.UpdateLead(id, { payementAllow: editingValue });
      
      if (response.status) {
        message.success('Payment status updated successfully');
        fetchLeads(true);
        setEditingId(null);
        setEditingValue('');
      } else {
        message.error('Failed to update payment status');
      }
    } catch (error) {
      console.error('Error updating payment status:', error);
      message.error('Error updating payment status');
    }
  };

  useEffect(() => {
    fetchLeads();
  }, [
    currentPage, 
    pageSize, 
    searchQuery,
    effectiveSearchFields,
    dateRange,
    filteredInfo.part,
    filteredInfo.paymentStatus,
    selectedAgentId,
    selectedServiceAgentId
  ]);

  const isSearching = searchText?.trim().length > 0;

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount || 0);
  };

  const columns = [

    {
      title: "Order No.",
      width: 100,
      key: "orderNumber",
      render: (_, record) => {
        if (record.orderNumber) {
          return (
            <div style={{ 
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              background: '#f0f0ff',
              padding: '4px 8px',
              borderRadius: 8,
              width: 'fit-content'
            }}>
              <FileTextOutlined style={{ color: '#722ed1', fontSize: 12 }} />
              <Text style={{ 
                color: '#722ed1', 
                fontSize: 12,
                fontWeight: 600,
                fontFamily: 'monospace'
              }}>
                #{record.orderNumber.slice(-8)}
              </Text>
              <Tooltip title="Copy Order Number">
                <Button
                  type="text"
                  size="small"
                  icon={<CopyOutlined style={{ fontSize: 10 }} />}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigator.clipboard.writeText(record.orderNumber);
                    message.success('Order number copied!');
                  }}
                  style={{ padding: 0, height: 18, width: 18, minWidth: 18 }}
                />
              </Tooltip>
            </div>
          );
        }
        return (
          <Tag color="default" style={{ borderRadius: 8 }}>Pending</Tag>
        );
      }
    },
    ...(isAdmin ? [{
      title: 'Sales-Agent',
      key: 'agent',
      width: 150,
      render: (_, record) => {
        const agentName = getAgentName(record);
        return (
          <Tooltip title={agentName}>
            <Space size={8}>
              <Avatar size={28} icon={<UserOutlined />} style={{ backgroundColor: '#722ed1' }} />
              <Text ellipsis style={{ fontSize: 13 }}>{agentName}</Text>
            </Space>
          </Tooltip>
        );
      },
    }] : []),
      {
    title: 'Payment Service-Agent',
    key: 'serviceAgent',
    width: 180,
    sorter: (a, b) => {
        const nameA = getServiceAgentName(a) || '';
        const nameB = getServiceAgentName(b) || '';
        return nameA.localeCompare(nameB);
    },
    render: (_, record) => {
        const serviceAgentName = getServiceAgentName(record);
        const isAssigned = !!serviceAgentName;
        
        return (
            <div 
                style={{ cursor: 'pointer' }}
                onClick={() => handleServiceAgentEdit(record)}
            >
                <Tooltip title={isAssigned ? `Click to change service agent` : 'Click to assign service agent'}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Avatar
                            size={32}
                            icon={<TeamOutlined />}
                            style={{
                                backgroundColor: isAssigned ? '#52c41a' : '#f0f0f0',
                                flexShrink: 0,
                            }}
                        >
                            {isAssigned && serviceAgentName?.[0]?.toUpperCase()}
                        </Avatar>
                        <div style={{ flex: 1 }}>
                            {isAssigned ? (
                                <>
                                    <Text
                                        ellipsis={{ tooltip: true }}
                                        style={{
                                            fontSize: 13,
                                            color: '#1f2937',
                                            display: 'block',
                                            fontWeight: 500
                                        }}
                                    >
                                        {serviceAgentName}
                                    </Text>
                                    <Text type="secondary" style={{ fontSize: 10 }}>
                                        Click to edit
                                    </Text>
                                </>
                            ) : (
                                <Text
                                    style={{
                                        fontSize: 13,
                                        color: '#1890ff',
                                        fontStyle: 'italic'
                                    }}
                                >
                                    + Assign Agent
                                </Text>
                            )}
                        </div>
                        <EditOutlined 
                            style={{ 
                                fontSize: 12, 
                                color: '#1890ff',
                                opacity: 0.6
                            }} 
                        />
                    </div>
                </Tooltip>
            </div>
        );
    },
},
    {
      title: 'Customer Details',
      key: 'customer',
      fixed: 'left',
      width: 260,
      render: (_, record) => (
        <Space direction="vertical" size={4} style={{ width: '100%' }}>
          <Text strong style={{ fontSize: 14 }}>
            {record.personalInfo?.fullName || 'N/A'}
          </Text>
          <Space size={8}>
            <MailOutlined style={{ color: '#1890ff', fontSize: 12 }} />
            <Text type="secondary" style={{ fontSize: 12 }}>
              {record.personalInfo?.email || 'N/A'}
            </Text>
          </Space>
          <Space size={8}>
            <PhoneOutlined style={{ color: '#52c41a', fontSize: 12 }} />
            <Text type="secondary" style={{ fontSize: 12 }}>
              {record.personalInfo?.phoneNumber || 'N/A'}
            </Text>
          </Space>
        </Space>
      ),
    },
    {
      title: "Vehicle",
      key: "vehicle",
      width: 180,
      render: (_, record) => (
        <div>
          <Tag color="blue">{record.vehicleInfo?.year || "N/A"}</Tag>
          <Text strong style={{ fontSize: 13, display: 'block', marginTop: 4 }}>
            {record.vehicleInfo?.make || "N/A"} {record.vehicleInfo?.model || ""}
          </Text>
          <Tag color="cyan" style={{ marginTop: 4 }}>
            Part: {record.vehicleInfo?.part || "N/A"}
          </Tag>
          {record.queueLead === true && (
            <Tooltip title="Queued Lead">
              <TbCircleDottedLetterQ style={{ fontSize: 14, color: "#1677ff", marginLeft: 8 }} />
            </Tooltip>
          )}
        </div>
      ),
    },
 {
    title: 'SPECIFICATION',
    key: 'specification',
    width: 280,
    render: (_, record) => {
        const specification = record.vehicleInfo?.specification || '';
        const hasSpecification = specification && specification.trim().length > 0;
        
        return (
            <div 
                style={{ 
                    cursor: 'pointer',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                }}
                onClick={() => handleSpecificationEdit(record)}
            >
                {/* Display Specification Content */}
                {hasSpecification ? (
                    <div 
                        style={{
                            background: '#f0f8ff',
                            padding: '12px',
                            borderRadius: '8px',
                            border: '1px solid #91d5ff',
                            transition: 'all 0.3s ease',
                            wordBreak: 'break-word',
                            wordWrap: 'break-word',
                            overflowWrap: 'break-word',
                            whiteSpace: 'pre-wrap',
                            minHeight: '80px',
                            position: 'relative'
                        }}
                    >
                        {/* Edit Icon - Top Right */}
                        <EditOutlined 
                            style={{ 
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                fontSize: 12,
                                color: '#1890ff',
                                opacity: 0.7
                            }} 
                        />
                        
                        {/* Specification Text */}
                        <Text style={{ 
                            fontSize: '12px',
                            display: 'block',
                            lineHeight: 1.5,
                            paddingRight: '20px'
                        }}>
                            {specification}
                        </Text>
                    </div>
                ) : (
                    <div 
                        style={{ 
                            textAlign: 'center', 
                            padding: '20px',
                            background: '#fafafa',
                            borderRadius: '8px',
                            border: '1px dashed #d9d9d9',
                            transition: 'all 0.3s ease',
                            position: 'relative'
                        }}
                    >
                        <EditOutlined 
                            style={{ 
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                fontSize: 12,
                                color: '#1890ff',
                                opacity: 0.7
                            }} 
                        />
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            <FileTextOutlined style={{ marginRight: '8px', fontSize: '14px' }} />
                            No specification added
                        </Text>
                        <Text type="secondary" style={{ fontSize: '11px', display: 'block', marginTop: '4px' }}>
                            Click to add
                        </Text>
                    </div>
                )}
                
                {/* Last Updated Info - if specification exists and has history */}
                {hasSpecification && record.vehicleInfo?.specificationUpdatedAt && (
                    <div style={{ 
                        marginTop: 6,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 4,
                        justifyContent: 'flex-end'
                    }}>
                        <Tooltip title={`Last updated: ${dayjs(record.vehicleInfo.specificationUpdatedAt).format('MMM DD, YYYY hh:mm A')}`}>
                            <Space size={4}>
                                <ClockCircleOutlined style={{ fontSize: 10, color: '#8c8c8c' }} />
                                <Text type="secondary" style={{ fontSize: 10 }}>
                                    Updated: {dayjs(record.vehicleInfo.specificationUpdatedAt).fromNow()}
                                </Text>
                            </Space>
                        </Tooltip>
                    </div>
                )}
            </div>
        );
    },
},
{
  title: 'Payment Status',
  key: 'paymentStatus',
  width: 220,
  render: (_, record) => {
    const paymentHistory = record.payementAllowHistory || [];
    const currentStatus = record.payementAllow;
    
    // ✅ Get the FIRST (oldest) entry with the current status
    const firstStatusEntry = [...paymentHistory]
      .sort((a, b) => new Date(a.changedAt) - new Date(b.changedAt)) // Oldest first
      .find(entry => entry.value === currentStatus);
    
    const statusChangeDate = firstStatusEntry?.changedAt;
    
    if ( editingId === record._id) {
      return (
        <Space direction="vertical" size={8} style={{ width: '100%' }}>
          <Select
            value={editingValue}
            onChange={(value) => handlePaymentStatusChange(record, value)}
            style={{ width: '100%' }}
            size="small"
          >
            <Option value="Yes">Paid</Option>
            <Option value="No">Pending</Option>
          </Select>
          <DatePicker
            value={editingSalesMadeDate}
            onChange={setEditingSalesMadeDate}
            format="MM/DD/YYYY"
            size="small"
            placeholder="Select date"
            style={{ width: '100%' }}
          />
          <Space size={4}>
            <Button 
              type="primary" 
              size="small" 
              icon={<CheckOutlined />} 
              onClick={() => handlePaymentStatusUpdate(record._id)} 
              loading={savingPaymentStatus}
            />
            <Button size="small" icon={<CloseOutlined />} onClick={handleEditCancel} />
          </Space>
        </Space>
      );
    }
    
    return (
      <div>
        <div>
          <Tag 
            color={currentStatus === 'Yes' ? 'success' : 'warning'}
            style={{ cursor: isAdmin ? 'pointer' : 'default', borderRadius: 16, padding: '4px 12px' }}
            onClick={() => isAdmin && handleEditStart(record)}
          >
            {currentStatus === 'Yes' ? '✓ Paid' : '⚠ Pending'}
          </Tag>
          {!editingId && (
            <Button
              type="text"
              size="small"
              icon={<EditOutlined />}
              onClick={() => handleEditStart(record)}
              style={{ marginLeft: 8 }}
            />
          )}
        </div>
        
        {statusChangeDate && (
          <div style={{ marginTop: 4 }}>
            <Tooltip title="First time this status was set">
              <Space size={4}>
                <ClockCircleOutlined style={{ fontSize: 10, color: '#8c8c8c' }} />
                <Text type="secondary" style={{ fontSize: 10 }}>
                  Since: {formatDateTimeDMY(statusChangeDate)}
                </Text>
              </Space>
            </Tooltip>
          </div>
        )}
      </div>
    );
  },
},
    {
      title: 'DL',
      key: 'dlCopy',
      width: 100,
      render: (_, record) => (
        <Tag color={record.dlCopy === 'Yes' ? 'success' : 'default'}>
          {record.dlCopy || 'No'}
        </Tag>
      ),
    },
    {
      title: 'Sale Made Date',
      key: 'saleMadeDate',
      width: 150,
sorter: (a, b) => {
  const dateA = getSalesMadeDate(a);
  const dateB = getSalesMadeDate(b);

  if (!dateA && !dateB) return 0;
  if (!dateA) return -1;
  if (!dateB) return 1;

  return new Date(dateA) - new Date(dateB);
},
      sortOrder: sortedInfo.field === 'saleMadeDate' && sortedInfo.order,
      render: (_, record) => {
        const salesMadeDate = getSalesMadeDate(record);
        const isEditing = editingSalesMadeId === record._id;
        
        if (isEditing && isAdmin) {
          return (
            <Space direction="vertical" size={4}>
<DatePicker
  value={editingSalesMadeDate}
  onChange={setEditingSalesMadeDate}
  format="MM/DD/YYYY"
  size="small"
  placeholder="MM/DD/YYYY"
/>
              <Space size={4}>
                <Button size="small" type="primary" icon={<CheckOutlined />} onClick={() => handleSalesMadeDateUpdate(record._id)} loading={savingSalesMade} />
                <Button size="small" icon={<CloseOutlined />} onClick={handleSalesMadeEditCancel} />
              </Space>
            </Space>
          );
        }
        
        return (
          <div>
            <Text style={{ fontSize: 13 }}>
              {salesMadeDate ? formatDateDMY(salesMadeDate) : 'Not Set'}
            </Text>
            {salesMadeDate && (
              <div>
                <Text type="secondary" style={{ fontSize: 11 }}>
                  {dayjs(salesMadeDate).fromNow()}
                </Text>
              </div>
            )}
            {isAdmin && !isEditing && (
              <EditOutlined
                style={{ color: '#1890ff', cursor: 'pointer', fontSize: 12, marginLeft: 8 }}
                onClick={() => handleSalesMadeEditStart(record)}
              />
            )}
          </div>
        );
      },
    },
  {
  title: 'Payment Date',
  key: 'lastPaymentDate',
  width: 150,
  sorter: (a, b) => {
    const dateA = getLastPaymentDate(a);
    const dateB = getLastPaymentDate(b);
    if (!dateA && !dateB) return 0;
    if (!dateA) return 1;
    if (!dateB) return -1;
    return new Date(dateB) - new Date(dateA);
  },
  render: (_, record) => {
    const lastPaymentDate = getLastPaymentDate(record);
    const advancePayments = record.advancePayments || [];
    const latestPayment = advancePayments.length > 0 
      ? [...advancePayments].sort((a, b) => new Date(b.date) - new Date(a.date))[0]
      : null;
    const isEditing = editingPaymentDateId === record._id;
    
    if (isEditing && isAdmin) {
      return (
        <Space direction="vertical" size={4}>
          <DatePicker
            value={editingPaymentDate}
            onChange={setEditingPaymentDate}
            format="MM/DD/YYYY"
            size="small"
            placeholder="Select date"
          />
          <Space size={4}>
            <Button 
              size="small" 
              type="primary" 
              icon={<CheckOutlined />} 
              onClick={() => handlePaymentDateUpdate(record._id)} 
              loading={savingPaymentDate}
            />
            <Button size="small" icon={<CloseOutlined />} onClick={handlePaymentDateEditCancel} />
          </Space>
        </Space>
      );
    }
    
    if (!lastPaymentDate) {
      return (
        <div>
          <Text type="secondary" style={{ fontSize: 12, fontStyle: 'italic' }}>No payments yet</Text>
          {isAdmin && (
            <Button
              type="text"
              size="small"
              icon={<EditOutlined />}
              onClick={() => handlePaymentDateEditStart(record)}
              style={{ marginLeft: 8 }}
            />
          )}
        </div>
      );
    }
    
    return (
      <div>
        <div>
          <Text style={{ fontSize: 13 }}>{formatDateDMY(lastPaymentDate)}</Text>
          {isAdmin && !isEditing && (
            <EditOutlined
              style={{ color: '#1890ff', cursor: 'pointer', fontSize: 12, marginLeft: 8 }}
              onClick={() => handlePaymentDateEditStart(record)}
            />
          )}
        </div>
   
      
      </div>
    );
  },
},
 {
    title: 'Specification',
    key: 'specification',
    width: 280,
    render: (_, record) => {
        const specification = record.vehicleInfo?.specification || '';
        const hasSpecification = specification && specification.trim().length > 0;
        
        return (
            <div 
                style={{ 
                    cursor: 'pointer',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                }}
                onClick={() => handleSpecificationEdit(record)}
            >
                {/* Display Specification Content */}
                {hasSpecification ? (
                    <div 
                        style={{
                            background: '#f0f8ff',
                            padding: '12px',
                            borderRadius: '8px',
                            border: '1px solid #91d5ff',
                            transition: 'all 0.3s ease',
                            wordBreak: 'break-word',
                            wordWrap: 'break-word',
                            overflowWrap: 'break-word',
                            whiteSpace: 'pre-wrap',
                            minHeight: '80px',
                            position: 'relative'
                        }}
                    >
                        {/* Edit Icon - Top Right */}
                        <EditOutlined 
                            style={{ 
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                fontSize: 12,
                                color: '#1890ff',
                                opacity: 0.7
                            }} 
                        />
                        
                        {/* Specification Text */}
                        <Text style={{ 
                            fontSize: '12px',
                            display: 'block',
                            lineHeight: 1.5,
                            paddingRight: '20px'
                        }}>
                            {specification}
                        </Text>
                    </div>
                ) : (
                    <div 
                        style={{ 
                            textAlign: 'center', 
                            padding: '20px',
                            background: '#fafafa',
                            borderRadius: '8px',
                            border: '1px dashed #d9d9d9',
                            transition: 'all 0.3s ease',
                            position: 'relative'
                        }}
                    >
                        <EditOutlined 
                            style={{ 
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                fontSize: 12,
                                color: '#1890ff',
                                opacity: 0.7
                            }} 
                        />
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            <FileTextOutlined style={{ marginRight: '8px', fontSize: '14px' }} />
                            No specification added
                        </Text>
                        <Text type="secondary" style={{ fontSize: '11px', display: 'block', marginTop: '4px' }}>
                            Click to add
                        </Text>
                    </div>
                )}
                
                {/* Last Updated Info - if specification exists and has history */}
                {hasSpecification && record.vehicleInfo?.specificationUpdatedAt && (
                    <div style={{ 
                        marginTop: 6,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 4,
                        justifyContent: 'flex-end'
                    }}>
                        <Tooltip title={`Last updated: ${dayjs(record.vehicleInfo.specificationUpdatedAt).format('MMM DD, YYYY hh:mm A')}`}>
                            <Space size={4}>
                                <ClockCircleOutlined style={{ fontSize: 10, color: '#8c8c8c' }} />
                                <Text type="secondary" style={{ fontSize: 10 }}>
                                    Updated: {dayjs(record.vehicleInfo.specificationUpdatedAt).fromNow()}
                                </Text>
                            </Space>
                        </Tooltip>
                    </div>
                )}
            </div>
        );
    },
},
    {
      title: 'Amount',
      key: 'amount',
      width: 140,
      sorter: (a, b) => (a.totalAmount || 0) - (b.totalAmount || 0),
      render: (_, record) => {
        const totalAmount = record.totalAmount || 0;
        const paidAmount = record.paidAmount || 0;
        const balance = totalAmount - paidAmount;
        
        return (
          <div>
            <div>
              <Text type="secondary" style={{ fontSize: 11 }}>Total:</Text>
              <Tag color="blue" style={{ marginLeft: 8 }}>{formatCurrency(totalAmount)}</Tag>
            </div>
            <div style={{ marginTop: 4 }}>
              <Text type="secondary" style={{ fontSize: 11 }}>Paid:</Text>
              <Text strong style={{ color: '#52c41a', marginLeft: 8 }}>{formatCurrency(paidAmount)}</Text>
            </div>
            <div style={{ marginTop: 4 }}>
              <Text type="secondary" style={{ fontSize: 11 }}>Balance:</Text>
              <Text strong style={{ color: balance > 0 ? '#fa8c16' : '#52c41a', marginLeft: 8 }}>
                {formatCurrency(balance)}
              </Text>
            </div>
            <Button
              size="small"
              type="link"
              icon={<EditOutlined />}
              onClick={() => handleAmountEditOpen(record)}
              style={{ padding: 0, marginTop: 4 }}
            >
              Edit
            </Button>
          </div>
        );
      }
    },
    {
    title: 'Comment',
    key: 'paymentPageComment',
    width: 280,
    render: (_, record) => {
        const comments = record.paymentPageComment || [];
        const latestComment = comments.length > 0 ? comments[comments.length - 1] : null;
        
        return (
            <div>
             

                {/* Display Latest Comment */}
                {latestComment ? (
                    <div 
                        style={{
                            background: '#fafafa',
                            padding: '8px 10px',
                            borderRadius: '8px',
                            border: '1px solid #f0f0f0',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            wordBreak: 'break-word',      // Add this
                            wordWrap: 'break-word',       // Add this
                            overflowWrap: 'break-word',   // Add this
                            whiteSpace: 'normal'          // Add this
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setSelectedLeadForComment(record);
                            setCommentsModalVisible(true);
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
                            <Text type="secondary" style={{ fontSize: '10px' }}>
                                <ClockCircleOutlined style={{ marginRight: '4px' }} />
                                {formatCommentDate(latestComment.changedAt)}
                            </Text>
                            {comments.length > 1 && (
                                <Tag 
                                    color="blue" 
                                    style={{ 
                                        fontSize: '10px', 
                                        padding: '0 4px', 
                                        margin: 0,
                                        cursor: 'pointer'
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedLeadForComment(record);
                                        setCommentsModalVisible(true);
                                    }}
                                >
                                    +{comments.length - 1} more
                                </Tag>
                            )}
                        </div>
                        <Text style={{ 
                            fontSize: '12px', 
                            display: 'block', 
                            wordBreak: 'break-word',    // Add this
                            whiteSpace: 'pre-wrap'       // Add this for preserving whitespace and wrapping
                        }}>
                            {latestComment.comment.length > 80 
                                ? `${latestComment.comment.substring(0, 80)}...` 
                                : latestComment.comment}
                        </Text>
                    </div>
                ) : (
                    <div 
                        style={{ 
                            textAlign: 'center', 
                            padding: '12px',
                            background: '#fafafa',
                            borderRadius: '8px',
                            border: '1px solid #f0f0f0',
                            cursor: 'pointer'
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setSelectedLeadForComment(record);
                            setCommentsModalVisible(true);
                        }}
                    >
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            <CommentOutlined style={{ marginRight: '4px', fontSize: '14px' }} />
                            No comments yet
                        </Text>
                    </div>
                )}
                   <Button
                    type="primary"
                    size="small"
                    icon={<CommentOutlined />}
                    onClick={(e) => {
                        e.stopPropagation();
                        setSelectedLeadForComment(record);
                        setNewComment('');
                        setCommentsModalVisible(true);
                    }}
                    style={{ 
                        marginBottom: '12px',
                        width: '100%',
                        fontSize: '12px'
                    }}
                >
                    Add Comment
                </Button>
            </div>
        );
    },
},
   
 
    {
      title: '',
      key: 'actions',
      width: 60,
      fixed: 'right',
      align: 'center',
      render: (_, record) => (
        <Tooltip title="View Details">
          <Button 
            type="primary"
            shape="circle"
            icon={<EyeOutlined />} 
            onClick={() => handleView(record)}
            style={{ background: '#1890ff', border: 'none' }}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <div style={{ padding: 24, minHeight: "100vh", background: '#f5f7fa' }}>
      {/* Header */}
      <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <Card style={{ marginBottom: 24, borderRadius: 16 }}>
          <Row gutter={[24, 24]} align="middle">
            <Col xs={24} md={12}>
              <Space size={16}>
                <Avatar size={56} style={{ background: '#faad14' }} icon={<WalletOutlined style={{ fontSize: 28 }} />} />
                <div>
                  <Title level={2} style={{ margin: 0 }}>Pending Payments</Title>
                  <Text type="secondary">Track and manage pending payment leads</Text>
                </div>
              </Space>
            </Col>
            <Col xs={24} md={12}>
              <Row gutter={16}>
                <Col span={8}>
                  <Card size="small">
                    <Statistic title="Total Pending" value={totalRecords} suffix="leads" />
                  </Card>
                </Col>
                <Col span={8}>
                  <Card size="small">
                    <Statistic 
                      title="Total Amount" 
                      value={leads.reduce((sum, l) => sum + (l.totalAmount || 0), 0)} 
                      formatter={(value) => formatCurrency(value)}
                    />
                  </Card>
                </Col>
                <Col span={8}>
                  <Card size="small">
                    <Statistic 
                      title="Average Amount" 
                      value={totalRecords > 0 ? leads.reduce((sum, l) => sum + (l.totalAmount || 0), 0) / totalRecords : 0}
                      formatter={(value) => formatCurrency(value)}
                    />
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </motion.div>

      {/* Filters */}
      <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}>
        <Card bordered={false} style={{ borderRadius: 16, marginBottom: 24 }}>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={8}>
              <Space.Compact block>
                <SearchFieldsSelect value={searchFields} onChange={setSearchFields} />
                <Input
                  placeholder={getSearchFieldsPlaceholder(searchFields)}
                  prefix={<SearchOutlined />}
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  allowClear
                  size="large"
                />
              </Space.Compact>
            </Col>
            {isAdmin && (
              <Col xs={24} md={4}>
                <Select
                  placeholder="Filter by Agent"
                  value={selectedAgentId}
                  onChange={setSelectedAgentId}
                  style={{ width: '100%' }}
                  size="large"
                  allowClear
                  showSearch
                >
                  {agents.map(agent => (
                    <Option key={agent._id} value={agent._id}>
                      {agent.firstName} {agent.lastName}
                    </Option>
                  ))}
                </Select>
              </Col>
            )}
            <Col xs={24} md={4}>
              <Select
                placeholder="Quick Date"
                onChange={handleQuickDateFilter}
                value={quickDateFilter}
                size="large"
                style={{ width: '100%' }}
              >
                <Option value="today">Today</Option>
                <Option value="yesterday">Yesterday</Option>
                <Option value="thisWeek">This Week</Option>
                <Option value="thisMonth">This Month</Option>
                <Option value="lastMonth">Last Month</Option>
                <Option value="thisQuarter">This Quarter</Option>
                <Option value="thisYear">This Year</Option>
                <Option value="custom">Custom Range</Option>
              </Select>
            </Col>
            <Col xs={24} md={isAdmin ? 7 : 8}>
<RangePicker
  style={{ width: '100%' }}
  onChange={handleDateRangeChange}
  value={dateRange}
  size="large"
  format="MM/DD/YYYY"
  placeholder={['Start Date', 'End Date']}
/>
            </Col>
            <Col xs={24} md={isAdmin ? 4 : 6}>
              <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                <Button icon={<ReloadOutlined />} onClick={handleRefresh} loading={refreshing} size="large" />
                <Button icon={<ClearOutlined />} onClick={handleClearFilters} size="large">Clear</Button>
              </Space>
            </Col>
          </Row>
        </Card>
      </motion.div>

      {/* Table */}
      <Card bordered={false} style={{ borderRadius: 16, overflow: 'hidden' }} bodyStyle={{ padding: 0 }}>
        <Table
          columns={columns}
          dataSource={leads}
          rowKey="_id"
          loading={loading}
          onChange={handleTableChange}
          scroll={{ x: isAdmin ? 1400 : 1200 }}
          size="middle"
           pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: totalRecords,
                showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} pending payments`,
                showSizeChanger: true,
                  position: ['topRight'], 
                pageSizeOptions: ['12', '24', '48', '96'],
                onChange: handlePaginationChange,
              }}
        />
        
        {leads.length > 0 && (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '20px 24px', background: '#fafafa' }}>
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={totalRecords}
              showSizeChanger
              pageSizeOptions={["10", "20", "50", "100"]}
              onChange={handlePaginationChange}
              showQuickJumper
              
              showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} pending payments`}
            />
          </div>
        )}
      </Card>

      
{/* Amount Edit Modal - WITH BOTH TOTAL AND PAID AMOUNT */}
<Modal
  title="Edit Payment Amounts"
  open={isAmountModalVisible}
  onCancel={handleAmountModalCancel}
  footer={[
    <Button key="cancel" onClick={handleAmountModalCancel} size="large">
      Cancel
    </Button>,
    <Button 
      key="submit" 
      type="primary" 
      loading={savingAmount} 
      size="large"
      onClick={async () => {
        try {
          const values = await amountForm.validateFields();
          await handleAmountModalSave(values);
        } catch (error) {
          console.error('Validation failed:', error);
        }
      }}
    >
      Update Amounts
    </Button>
  ]}
  width={500}
  centered
  destroyOnClose
>
  <Form 
    form={amountForm} 
    layout="vertical"
  >
    {selectedLeadForAmount && (
      <>
        <Card size="small" style={{ marginBottom: 20, background: '#f5f5f5' }}>
          <Text strong>{selectedLeadForAmount.personalInfo?.fullName || 'N/A'}</Text>
          <br />
          <Text type="secondary" style={{ fontSize: 12 }}>
            {selectedLeadForAmount.vehicleInfo?.make} {selectedLeadForAmount.vehicleInfo?.model} - {selectedLeadForAmount.vehicleInfo?.part}
          </Text>
        </Card>

        <Form.Item
          name="totalAmount"
          label="Total Amount"
          rules={[
            { required: true, message: 'Please enter total amount' },
            {
              validator: (_, value) => {
                const numValue = Number(value);
                if (!value || numValue <= 0) {
                  return Promise.reject('Amount must be greater than 0');
                }
                return Promise.resolve();
              }
            }
          ]}
        >
          <InputNumber
            style={{ width: '100%' }}
            size="large"
            min={0.01}
            step={0.01}
            prefix="$"
            placeholder="Enter total amount"
            precision={2}
            autoFocus
          />
        </Form.Item>
{/* <Form.Item
  name="paidAmount"
  label="Paid Amount"
  dependencies={['totalAmount']}
  rules={[
    { required: true, message: 'Please enter paid amount' },
    ({ getFieldValue }) => ({
      validator(_, value) {
        const numValue = Number(value);
        if (!value || numValue < 0) {
          return Promise.reject('Paid amount cannot be negative');
        }
        const totalAmount = getFieldValue('totalAmount') || selectedLeadForAmount?.totalAmount || 0;
        if (numValue > totalAmount) {
          return Promise.reject('Paid amount cannot exceed total amount');
        }
        return Promise.resolve();
      },
    }),
  ]}
>
  <InputNumber
    style={{ width: '100%' }}
    size="large"
    min={0}
    step={0.01}
    prefix="$"
    placeholder="Enter paid amount"
    precision={2}
  />
</Form.Item> */}

        <div style={{ 
          background: '#f0f2f5', 
          padding: '12px', 
          borderRadius: '8px',
          marginTop: '16px'
        }}>
          <Row gutter={16}>
            <Col span={12}>
              <Text type="secondary">Current Values:</Text>
              <div>
                <Text>Total: <strong>{formatCurrency(selectedLeadForAmount.totalAmount || 0)}</strong></Text>
              </div>
              <div>
                <Text>Paid: <strong>{formatCurrency(selectedLeadForAmount.paidAmount || 0)}</strong></Text>
              </div>
            </Col>
            <Col span={12}>
              <Text type="secondary">New Balance:</Text>
              <div>
                <Text strong style={{ fontSize: '18px', color: '#fa8c16' }}>
                  {formatCurrency(
                    (amountForm.getFieldValue('totalAmount') || selectedLeadForAmount.totalAmount || 0) - 
                    (amountForm.getFieldValue('paidAmount') || selectedLeadForAmount.paidAmount || 0)
                  )}
                </Text>
              </div>
            </Col>
          </Row>
        </div>

        <Alert
          message="Note: Changing paid amount affects the payment status"
          description="Balance will automatically recalculate based on total amount minus paid amount"
          type="info"
          showIcon
          style={{ marginTop: 16 }}
        />
      </>
    )}
  </Form>
</Modal>
        <Modal
   
    open={commentsModalVisible}
    onCancel={() => {
        setCommentsModalVisible(false);
        setSelectedLeadForComment(null);
        setNewComment('');
    }}
    footer={[
        <Button key="cancel" onClick={() => {
            setCommentsModalVisible(false);
            setSelectedLeadForComment(null);
            setNewComment('');
        }}>
            Cancel
        </Button>,
        <Button 
            key="submit" 
            type="primary" 
            onClick={handleAddComment}
            loading={addingComment}
            disabled={!newComment.trim()}
        >
            Add Comment
        </Button>
    ]}
    width={500}
>
    <div style={{ padding: '16px 0' }}>
      

        <div>
            <Text strong>Comment:</Text>
            <Input.TextArea
                placeholder="Enter your comment here..."
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                rows={4}
                maxLength={1000}
                showCount
                style={{ marginTop: '8px' }}
                autoFocus
            />
        </div>

        {/* Show existing comments if any */}
        {selectedLeadForComment?.paymentPageComment?.length > 0 && (
            <div style={{ marginTop: '20px' }}>
                <Divider />
                <Text strong>Previous Comments ({selectedLeadForComment.paymentPageComment.length})</Text>
                <div style={{ 
                    maxHeight: '200px', 
                    overflowY: 'auto', 
                    marginTop: '8px',
                    padding: '8px',
                    background: '#f5f5f5',
                    borderRadius: '8px'
                }}>
                    {[...selectedLeadForComment.paymentPageComment]
                        .sort((a, b) => new Date(b.changedAt) - new Date(a.changedAt))
                        .map((comment, idx) => (
                            <div key={idx} style={{ 
                                marginBottom: '12px', 
                                padding: '8px',
                                background: 'white',
                                borderRadius: '6px',
                                border: '1px solid #e8e8e8'
                            }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                                    <Text type="secondary" style={{ fontSize: '11px' }}>
                                        <ClockCircleOutlined style={{ marginRight: '4px' }} />
                                        {formatCommentDate(comment.changedAt)}
                                    </Text>
                                </div>
                                <Text style={{ fontSize: '13px' }}>{comment.comment}</Text>
                            </div>
                        ))}
                </div>
            </div>
        )}
    </div>
</Modal>
{/* Service Agent Assignment Modal */}
<Modal
    title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
                width: 40,
                height: 40,
                borderRadius: 12,
                background: 'linear-gradient(135deg, #52c41a 0%, #73d13d 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <TeamOutlined style={{ fontSize: 20, color: 'white' }} />
            </div>
            <div>
                <Title level={4} style={{ margin: 0 }}>Assign Service Agent</Title>
                <Text type="secondary" style={{ fontSize: 12 }}>
                    Select service agent for this lead
                </Text>
            </div>
        </div>
    }
    open={serviceAgentModalVisible}
    onCancel={() => {
        setServiceAgentModalVisible(false);
        setSelectedLeadForServiceAgent(null);
        setSelectedServiceAgentForLead(null);
    }}
    footer={null}
    width={500}
    centered
>
    <div style={{ padding: '16px 0' }}>
        {selectedLeadForServiceAgent && (
            <>
                {/* Customer Info Card */}
                <Card 
                    size="small" 
                    style={{ 
                        marginBottom: 20,
                        background: '#f5f5f5',
                        borderRadius: 12,
                        border: 'none'
                    }}
                    bodyStyle={{ padding: '12px 16px' }}
                >
                    <Space direction="vertical" size={4} style={{ width: '100%' }}>
                        <Text strong>
                            {selectedLeadForServiceAgent.personalInfo?.fullName || 'N/A'}
                        </Text>
                        <Text type="secondary" style={{ fontSize: 12 }}>
                            {selectedLeadForServiceAgent.vehicleInfo?.make} {selectedLeadForServiceAgent.vehicleInfo?.model} - {selectedLeadForServiceAgent.vehicleInfo?.part}
                        </Text>
                        {selectedLeadForServiceAgent.orderServiceHandledBy && (
                            <div style={{ 
                                marginTop: 8,
                                paddingTop: 8,
                                borderTop: '1px solid #e8e8e8'
                            }}>
                                <Text type="secondary" style={{ fontSize: 11 }}>
                                    Currently assigned: 
                                </Text>
                                <Text strong style={{ fontSize: 12, color: '#52c41a', marginLeft: 8 }}>
                                    {getServiceAgentName(selectedLeadForServiceAgent)}
                                </Text>
                            </div>
                        )}
                    </Space>
                </Card>

                {/* Service Agent Selection */}
                <div style={{ marginBottom: 24 }}>
                    <Text strong style={{ display: 'block', marginBottom: 8 }}>
                        Select Service Agent:
                    </Text>
                    <Select
                        value={selectedServiceAgentForLead}
                        onChange={setSelectedServiceAgentForLead}
                        style={{ width: '100%' }}
                        size="large"
                        placeholder="Choose an agent"
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        loading={loadingServiceAgents}
                    >
                        {Object.entries(serviceAgentsMap).map(([agentId, agentInfo]) => (
                            <Option key={agentId} value={agentId}>
                                <Space direction="vertical" size={0}>
                                    <Text strong>{agentInfo.name}</Text>
                                   
                                </Space>
                            </Option>
                        ))}
                    </Select>
                    <Text type="secondary" style={{ fontSize: 11, marginTop: 4, display: 'block' }}>
                        {selectedServiceAgentForLead ? 'Agent will be assigned to this lead' : 'Clear to unassign the current agent'}
                    </Text>
                </div>

                {/* Modal Actions */}
                <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                    <Button 
                        onClick={() => {
                            setServiceAgentModalVisible(false);
                            setSelectedLeadForServiceAgent(null);
                            setSelectedServiceAgentForLead(null);
                        }} 
                        size="large"
                    >
                        Cancel
                    </Button>
                    <Button 
                        type="primary" 
                        onClick={handleServiceAgentSave}
                        loading={savingServiceAgent}
                        size="large"
                        icon={<CheckOutlined />}
                    >
                        {selectedServiceAgentForLead ? 'Assign Agent' : 'Unassign Agent'}
                    </Button>
                </div>
            </>
        )}
    </div>
</Modal>
<Modal
    title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
                width: 40,
                height: 40,
                borderRadius: 12,
                background: 'linear-gradient(135deg, #52c41a 0%, #73d13d 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <FileTextOutlined style={{ fontSize: 20, color: 'white' }} />
            </div>
            <div>
                <Title level={4} style={{ margin: 0 }}>Vehicle Specification</Title>
                <Text type="secondary" style={{ fontSize: 12 }}>
                    Add or edit vehicle specifications
                </Text>
            </div>
        </div>
    }
    open={specificationModalVisible}
    onCancel={() => {
        setSpecificationModalVisible(false);
        setSelectedLeadForSpecification(null);
        setTempSpecification('');
    }}
    footer={[
        <Button 
            key="cancel" 
            onClick={() => {
                setSpecificationModalVisible(false);
                setSelectedLeadForSpecification(null);
                setTempSpecification('');
            }}
        >
            Cancel
        </Button>,
        <Button 
            key="submit" 
            type="primary" 
            onClick={handleSpecificationSave}
            loading={savingSpecification}
            icon={<CheckOutlined />}
        >
            Save Specification
        </Button>
    ]}
    width={600}
    centered
>
    <div style={{ padding: '16px 0' }}>
        {selectedLeadForSpecification && (
            <>
                {/* Customer & Vehicle Info Card */}
                <Card 
                    size="small" 
                    style={{ 
                        marginBottom: 20,
                        background: '#f5f5f5',
                        borderRadius: 12,
                        border: 'none'
                    }}
                    bodyStyle={{ padding: '12px 16px' }}
                >
                    <Row gutter={[16, 8]}>
                        <Col span={12}>
                            <Text type="secondary" style={{ fontSize: 11 }}>Customer</Text>
                            <div>
                                <Text strong>{selectedLeadForSpecification.personalInfo?.fullName || 'N/A'}</Text>
                            </div>
                        </Col>
                        <Col span={12}>
                            <Text type="secondary" style={{ fontSize: 11 }}>Vehicle</Text>
                            <div>
                                <Text strong>
                                    {selectedLeadForSpecification.vehicleInfo?.year || ''} {selectedLeadForSpecification.vehicleInfo?.make || ''} {selectedLeadForSpecification.vehicleInfo?.model || ''}
                                </Text>
                            </div>
                        </Col>
                        <Col span={12}>
                            <Text type="secondary" style={{ fontSize: 11 }}>Part</Text>
                            <div>
                                <Tag color="cyan">{selectedLeadForSpecification.vehicleInfo?.part || 'N/A'}</Tag>
                            </div>
                        </Col>
                        <Col span={12}>
                            <Text type="secondary" style={{ fontSize: 11 }}>Order Number</Text>
                            <div>
                                <Text strong code>{selectedLeadForSpecification.orderNumber || 'N/A'}</Text>
                            </div>
                        </Col>
                    </Row>
                </Card>

                {/* Specification Input */}
                <div style={{ marginBottom: 24 }}>
                    <Text strong style={{ display: 'block', marginBottom: 8 }}>
                        Specification Details:
                    </Text>
                    <Input.TextArea
                        placeholder="Enter vehicle specifications (e.g., engine type, transmission, color, features, condition, etc.)..."
                        value={tempSpecification}
                        onChange={(e) => setTempSpecification(e.target.value)}
                        rows={6}
                        maxLength={2000}
                        showCount
                        style={{ 
                            fontSize: '13px',
                            borderRadius: 8
                        }}
                        autoFocus
                    />
                    <Text type="secondary" style={{ fontSize: 11, marginTop: 4, display: 'block' }}>
                        Include important details about the part/vehicle condition, compatibility notes, or special instructions.
                    </Text>
                </div>

                {/* Current Specification Preview (if exists) */}
                {selectedLeadForSpecification.vehicleInfo?.specification && (
                    <div>
                        <Divider style={{ margin: '12px 0' }} />
                        <div style={{ 
                            background: '#f0f8ff', 
                            padding: '12px', 
                            borderRadius: 8,
                            border: '1px solid #91d5ff'
                        }}>
                            <Space size={8} style={{ marginBottom: 8 }}>
                                <FileTextOutlined style={{ color: '#1890ff' }} />
                                <Text strong style={{ fontSize: 12 }}>Current Specification:</Text>
                            </Space>
                            <Text style={{ 
                                fontSize: '12px', 
                                display: 'block',
                                wordBreak: 'break-word',
                                whiteSpace: 'pre-wrap'
                            }}>
                                {selectedLeadForSpecification.vehicleInfo.specification}
                            </Text>
                        </div>
                    </div>
                )}
            </>
        )}
    </div>
</Modal>
    </div>
  );
};

export default PendingPayment;

